import React, { useState } from "react";
import { getOneTourPackage } from "../../../lib/sysNavigation/SysNavigation";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { codeOk } from "../../../lib";
import {
  Select,
  TextArea,
  MyMessage,
  InputField,
  MyButton,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { useGeoPositionContext } from "../utils/geoPosition";
import { useAdminContext } from "../../../context/admin/AdminContext";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { _TYPES_ } from "../utils/types";
import BestTimeToVisit from "../../components/BestTimeToVisit";
import Pricing from "../../components/Pricing";
import TourImagesModal from "./addTourImages";
import GenerateDescription from "../utils/GenerateDescription";
import { DescriptionSection } from "../utils/AddSections";
import {
  FiImage,
  FiSun,
  FiList,
  FiShield,
  FiDollarSign,
  FiPlus,
  FiSettings,
} from "react-icons/fi";
import { FaSuitcaseRolling } from "react-icons/fa";

const TYPES = [
  "Regional Tourism",
  "National Tourism",
  "Adventure Tourism",
  "Beach Tourism",
  "Cultural Tourism",
  "Ecotourism",
  "Heritage Tourism",
  "Green Tourism",
  "Sustainable tourism",
  "Leisure",
  "Culinary",
  "Religious",
  "Music and Dance",
  "Traditional Craft",
];

const Edit = () => {
  const { sysAdmin } = useAdminContext();
  const { updateOneContent } = useDoSeeDataContext();
  const {
    tags,
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const tour: any = getOneTourPackage();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const tour_package_id = tour?.tour_package_id;
  const [thumbnail, setThumbnail] = useState<any>(tour?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState<any>(tour?.image_cdn_id);
  const [title, setTitle] = useState<any>(tour?.title);
  const [description, setDescription] = useState<any>(tour?.description);
  const [highlights, setHighlights] = useState<any>(tour?.highlights);
  const [itineraryFocus, setItineraryFocus] = useState<any>(
    tour?.itinerary_focus
  );
  const [groupSize, setGroupSize] = useState<any>(tour?.group_size);
  const [ageRange, setAgeRange] = useState<any>(tour?.age_range);
  const [flightTransport, setFlightTransport] = useState<any>(
    tour?.flight_transport
  );
  const [startCity, setStartCity] = useState<any>(tour?.start_city);
  const [endCity, setEndCity] = useState<any>(tour?.end_city);
  const [theme, setTheme] = useState<any>(tour?.theme);
  const [type, setType] = useState<any>(tour?.type);
  const [destination, setDestination] = useState<any>(tour?.destination);
  const [tripIncludes, setTripIncludes] = useState<any>(tour?.trip_includes);
  const [tripExcludes, setTripExcludes] = useState<any>(tour?.trip_excludes);
  const [priceFrom, setPriceFrom] = useState<any>(tour?.price_from);
  const [pricePerDay, setPricePerDay] = useState<any>(tour?.price_per_day);
  const [citiesIncluded, setCitiesIncluded] = useState<any>(
    tour?.cities_included
  );
  const [duration, setDuration] = useState<any>(tour?.duration);
  const [showTop, setShowTop] = useState<any>(tour?.show_top);
  const [tourStatus, setTourStatus] = useState<any>(tour?.status);
  const [hashtags, setHashtags] = useState<any>(tour?.hashtag);
  const [itineraries, setItineraries] = useState<any>(
    tour
      ? tour?.Itineraries?.map((x: any) => {
          return { title: x?.title, description: x?.description };
        })
      : [{ title: null, description: null }]
  );
  const [safetyInfos, setSafetyInfos] = useState<any>(
    tour
      ? tour?.SafetyInfos?.map((x: any) => {
          return { title: x?.title, description: x?.description };
        })
      : [{ title: null, description: null }]
  );

  const [bestTime, setBestTime] = useState<any>(
    tour?.best_time_to_visit ? tour?.best_time_to_visit : []
  );
  const [pricing, setPricing] = useState<any>(tour?.Pricings);

  const [showTourImages, setShowTourImages] = useState(false);
  const [tourImages, setTourImages] = useState<any>(tour?.TourPackageImages);
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const tourRoutes = "/data/tour/package";

  const responses = (isError: any, msg: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg);
  };

  const updateOneTourHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) responses(true, "Image Required");
    else await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      description: description,
      highlights: highlights,
      itinerary_focus: itineraryFocus,
      group_size: groupSize,
      age_range: ageRange,
      flight_transport: flightTransport,
      start_city: startCity,
      end_city: endCity,
      theme: theme,
      destination: destination,
      trip_includes: tripIncludes,
      trip_excludes: tripExcludes,
      price_from: String(priceFrom),
      price_per_day: String(pricePerDay),
      cities_included: citiesIncluded,
      duration: String(duration),
      type: type ? type : "Regional Tourism",
      show_top: showTop,
      hashtag: `${tags}, ${hashtags}`,
      company_id: tour?.company_id || sysAdmin?.company_id,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "...",
      status: tourStatus,
      itineraries: itineraries
        ? itineraries?.filter((val: any) => val.title && val.description)
        : [],
      safety_infos: safetyInfos
        ? safetyInfos?.filter((val: any) => val.title && val.description)
        : [],
      best_time_to_visit: bestTime?.length > 0 ? String(bestTime) : null,
      pricing: pricing,
      tour_images: tourImages?.filter((x: any) => x?.thumbnail !== null),
    };

    const { message, status } = await updateOneContent({
      data_id: tour_package_id,
      data: data,
      content: _TYPES_.TOURPACKAGE,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });
    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  const addToType = (value: string) =>
    setType((type ? type + "," : "") + value);

  const removeFromType = (value: string) => {
    const arr = type
      ?.split(",")
      .filter((pos: string) => value !== pos && value !== "");
    let stream = "";
    arr.forEach(
      (v: string, i: number) =>
        (stream = i < arr.length - 1 ? stream + v + "," : stream + v)
    );
    setType(stream);
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  const onChangeNoticeReset = (setter: (v: any) => void) => (e: any) => {
    setter(e.target.value);
    clearMessages();
  };

  return (
    <AddPageShell
      backRoute={tourRoutes}
      eyebrow="DoSee Data • Tour Packages"
      title="Edit Tour Package"
      subtitle={`Update a tour package for ${entry_label || "this destination"}.`}
      icon={<FaSuitcaseRolling className="h-5 w-5" />}
      size="xl"
      modals={
        <>
          {showDescriptionModal ? (
            <GenerateDescription
              setDescription={setDescription}
              setShowDescriptionModal={setShowDescriptionModal}
            />
          ) : null}
          <TourImagesModal
            showModal={showTourImages}
            onClick={() => setShowTourImages(false)}
            setTourImages={setTourImages}
            tourImages={tourImages}
          />
        </>
      }
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneTourHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null as any);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="A signature shot of the destination."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.TOUR_PACKAGES)}
        />
      </AddSection>

      <AddSection
        title="Tour Package Type"
        hint="Tag the package with one or more tourism categories."
      >
        <div className="flex flex-wrap gap-2">
          {TYPES.map((val) => {
            const on = type?.toString().split(",").includes(val);
            return (
              <span
                key={val}
                role="button"
                tabIndex={0}
                onClick={() => (on ? removeFromType(val) : addToType(val))}
                onKeyDown={(e) =>
                  (e.key === "Enter" || e.key === " ") &&
                  (on ? removeFromType(val) : addToType(val))
                }
                className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs cursor-pointer capitalize transition-colors ${
                  on
                    ? "border-brand bg-brand/10 text-brand"
                    : "border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50"
                }`}
              >
                {on ? (
                  <MdCheckBox className="text-base" />
                ) : (
                  <MdCheckBoxOutlineBlank className="text-base" />
                )}
                {val}
              </span>
            );
          })}
        </div>
      </AddSection>

      <AddSection
        title="Best Time To Visit"
        hint="Months travellers should target."
        icon={<FiSun className="h-4 w-4" />}
      >
        <BestTimeToVisit bestTime={bestTime} setBestTime={setBestTime} />
      </AddSection>

      <AddSection
        title="Tour Details"
        hint="Core fields that describe the package."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
          <InputField
            props={{
              id: "title",
              title: "Tour Title",
              type: "text",
              value: title || "",
              onChange: onChangeNoticeReset(setTitle),
            }}
          />
          <Select
            props={{
              id: "top",
              title: "Show In Top Tours",
              option: ["no", "yes"],
              preselect:
                showTop !== null && showTop !== undefined
                  ? [{ name: showTop === 0 ? "no" : "yes" }]
                  : null,
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setShowTop(0);
                else setShowTop(1);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "groupSize",
              title: "Group Size",
              type: "text",
              value: groupSize || "",
              onChange: onChangeNoticeReset(setGroupSize),
            }}
          />
          <InputField
            props={{
              id: "flightTransport",
              title: "Flight fee included?",
              type: "text",
              value: flightTransport || "",
              onChange: onChangeNoticeReset(setFlightTransport),
            }}
          />
          <InputField
            props={{
              id: "startCity",
              title: "Start City",
              type: "text",
              value: startCity || "",
              onChange: onChangeNoticeReset(setStartCity),
            }}
          />
          <InputField
            props={{
              id: "endCity",
              title: "End City",
              type: "text",
              value: endCity || "",
              onChange: onChangeNoticeReset(setEndCity),
            }}
          />
          <InputField
            props={{
              id: "priceFrom",
              title: "Price From (USD)",
              type: "text",
              value: priceFrom ? parseInt(priceFrom) : "",
              onChange: (e: any) => {
                setPriceFrom(parseInt(e.target.value));
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "pricePerDay",
              title: "Price Per Day (USD)",
              type: "text",
              value: pricePerDay ? parseInt(pricePerDay) : "",
              onChange: (e: any) => {
                setPricePerDay(parseInt(e.target.value));
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "citiesIncluded",
              title: "Cities Included (comma separated)",
              type: "text",
              value: citiesIncluded || "",
              onChange: onChangeNoticeReset(setCitiesIncluded),
            }}
          />
          <InputField
            props={{
              id: "duration",
              title: "Duration (Days)",
              type: "text",
              value: duration ? parseInt(duration) : "",
              onChange: (e: any) => {
                const amount = parseInt(e.target.value);
                setDuration(amount);
                const array = Array.from({ length: amount }).map((_, key) => {
                  return {
                    title: `Day ${key + 1} Itinerary`,
                    description: null,
                  };
                });
                setItineraries(array);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "itineraryFocus",
              title: "Itinerary Focus",
              option: ["visible", "invisible"],
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setItineraryFocus(1);
                else setItineraryFocus(0);
                clearMessages();
              },
            }}
          />
          <TextArea
            props={{
              id: "highlights",
              title: "Highlights (comma separated)",
              type: "text",
              value: highlights || "",
              onChange: onChangeNoticeReset(setHighlights),
            }}
          />
          <TextArea
            props={{
              id: "ageRange",
              title: "Age Range (comma separated)",
              type: "text",
              value: ageRange || "",
              onChange: onChangeNoticeReset(setAgeRange),
            }}
          />
          <TextArea
            props={{
              id: "theme",
              title: "Theme (comma separated)",
              type: "text",
              value: theme || "",
              onChange: onChangeNoticeReset(setTheme),
            }}
          />
          <TextArea
            props={{
              id: "destination",
              title: "Destination (comma separated)",
              type: "text",
              value: destination || "",
              onChange: onChangeNoticeReset(setDestination),
            }}
          />
          <TextArea
            props={{
              id: "tripIncludes",
              title: "Trip Includes (comma separated)",
              type: "text",
              value: tripIncludes || "",
              onChange: onChangeNoticeReset(setTripIncludes),
            }}
          />
          <TextArea
            props={{
              id: "tripExcludes",
              title: "Trip Excludes (comma separated)",
              type: "text",
              value: tripExcludes || "",
              onChange: onChangeNoticeReset(setTripExcludes),
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <AddSection
        title="Itineraries"
        hint="Day-by-day breakdown — auto-generated from duration."
        icon={<FiList className="h-4 w-4" />}
      >
        <div className="space-y-4">
          {itineraries?.map((itinerary: any, index: number) => (
            <div
              key={index}
              className="rounded-xl border border-gray-100 bg-gray-50 p-4"
            >
              <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                <InputField
                  props={{
                    id: `itinerary-title-${index}`,
                    title: "Title",
                    type: "text",
                    disabled: true,
                    value: itinerary?.title || "",
                    onChange: (e: any) => {
                      setItineraries([
                        ...itineraries.map((item: any, i: number) => {
                          if (i === index) item.title = e.target.value;
                          return item;
                        }),
                      ]);
                      clearMessages();
                    },
                  }}
                />
                <TextArea
                  props={{
                    id: `itinerary-description-${index}`,
                    title: "Description",
                    type: "text",
                    value: itinerary?.description || "",
                    onChange: (e: any) => {
                      setItineraries([
                        ...itineraries?.map((item: any, i: number) => {
                          if (i === index) item.description = e.target.value;
                          return item;
                        }),
                      ]);
                      clearMessages();
                    },
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </AddSection>

      <AddSection
        title="Safety Infos"
        hint="Things travellers should know about safety."
        icon={<FiShield className="h-4 w-4" />}
        actions={
          <MyButton
            type="button"
            className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-br from-brand to-primary px-3 py-2 text-xs font-semibold text-white shadow hover:opacity-95"
            onClick={() =>
              setSafetyInfos((it: any) => [
                ...it,
                { title: null, description: null },
              ])
            }
          >
            <FiPlus className="h-4 w-4" />
            Add Safety Info
          </MyButton>
        }
      >
        <div className="space-y-4">
          {safetyInfos?.map((safe: any, index: number) => (
            <div
              key={index}
              className="rounded-xl border border-gray-100 bg-gray-50 p-4"
            >
              <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                <InputField
                  props={{
                    id: `safety-title-${index}`,
                    title: "Title",
                    type: "text",
                    value: safe?.title || "",
                    onChange: (e: any) => {
                      setSafetyInfos([
                        ...safetyInfos.map((item: any, i: number) => {
                          if (i === index) item.title = e.target.value;
                          return item;
                        }),
                      ]);
                      clearMessages();
                    },
                  }}
                />
                <TextArea
                  props={{
                    id: `safety-description-${index}`,
                    title: "Description",
                    type: "text",
                    value: safe?.description || "",
                    onChange: (e: any) => {
                      setSafetyInfos([
                        ...safetyInfos.map((item: any, i: number) => {
                          if (i === index) item.description = e.target.value;
                          return item;
                        }),
                      ]);
                      clearMessages();
                    },
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </AddSection>

      <AddSection
        title="More Images"
        hint="Optional gallery for this tour."
        icon={<FiPlus className="h-4 w-4" />}
      >
        <MyButton
          type="button"
          className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-800 shadow-sm hover:bg-gray-50"
          onClick={() => setShowTourImages(true)}
        >
          <FiPlus className="h-4 w-4" />
          Click to change or add more images
          {tourImages?.length > 0 ? (
            <span className="ml-2 inline-flex items-center justify-center rounded-full bg-brand/10 px-2 text-xs font-bold text-brand">
              {tourImages.length}
            </span>
          ) : null}
        </MyButton>
      </AddSection>

      <AddSection
        title="Visibility"
        hint="Where this entry appears."
        icon={<FiSettings className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <Select
            props={{
              id: "tour_status",
              title: "Status",
              option: ["visible", "invisible"],
              preselect:
                tourStatus !== null && tourStatus !== undefined
                  ? [
                      {
                        name: tourStatus === 1 ? "visible" : "invisible",
                      },
                    ]
                  : null,
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setTourStatus(1);
                else setTourStatus(0);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Edit;
